export default __webpack_public_path__ + "static/media/Futura-Medium-Italic.6180d54a.woff";